<div class="overlay"
     *ngIf="isOpen"
     [@overlay]="'isOpen'"
     (click)="close()"></div>

<mat-toolbar [class.open]="isOpen">
  <ng-content></ng-content>
</mat-toolbar>

<div class="panel-wrapper" [class.open]="isOpen">
  <ng-content select="cui-navbar-panel"></ng-content>
</div>

<div class="panel-concealer"></div>



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/navigation/navbar/navbar.component.html